var _g, _path, _path2, _path3, _path4, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgYellow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter_ddii_yellow)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50 94C74.3005 94 94 74.3005 94 50C94 25.6995 74.3005 6 50 6C25.6995 6 6 25.6995 6 50C6 74.3005 25.6995 94 50 94Z",
    fill: "#E3C19A"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M89.7057 50.0002C89.7057 28.0682 71.9264 10.2889 49.9945 10.2889C28.0625 10.2889 10.2832 28.0682 10.2832 50.0002C10.2832 71.9321 28.0625 89.7114 49.9945 89.7114C71.9264 89.7114 89.7057 71.9321 89.7057 50.0002Z",
    fill: "#FBF4ED"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M50.0002 87.2171C70.5545 87.2171 87.2171 70.5545 87.2171 50.0002C87.2171 29.4458 70.5545 12.7832 50.0002 12.7832C29.4458 12.7832 12.7832 29.4458 12.7832 50.0002C12.7832 70.5545 29.4458 87.2171 50.0002 87.2171Z",
    fill: "url(#paint_linear_yellow)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.5616 51.3098C28.1439 54.6296 37.7263 55.8139 46.878 51.3098C56.0298 46.8057 69.0934 43.8449 76.7198 44.8318C79.311 45.2177 81.876 45.7631 84.4001 46.4648C83.2183 37.8668 78.8514 30.026 72.1639 24.4943C65.4765 18.9627 56.9559 16.1434 48.2888 16.5947C39.6218 17.046 31.44 20.7349 25.3632 26.9312C19.2865 33.1275 15.7576 41.3795 15.4751 50.0537C16.3544 50.5023 17.3772 50.8612 18.5616 51.3098Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.7681 59.8334C22.4565 73.3277 35.9328 84.3815 49.8937 84.3815C59.7093 84.2739 70.494 78.8726 75.5902 72.1075C77.3847 64.5708 61.5038 73.6327 49.8937 73.4892C35.4663 73.7942 20.0699 53.176 16.7681 59.8334Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter_ddii_yellow",
    x: 0,
    y: 0.5,
    width: 100,
    height: 99,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 0.5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.380392 0 0 0 0 0.227451 0 0 0 0 0.0666667 0 0 0 0.8 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -1,
    dy: -0.5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.380392 0 0 0 0 0.227451 0 0 0 0 0.0666667 0 0 0 0.8 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow",
    result: "effect2_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -5,
    dy: -5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.380392 0 0 0 0 0.227451 0 0 0 0 0.0666667 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect3_innerShadow"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 5,
    dy: 5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.380392 0 0 0 0 0.227451 0 0 0 0 0.0666667 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect3_innerShadow",
    result: "effect4_innerShadow"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint_linear_yellow",
    x1: 49.408,
    y1: 15.2057,
    x2: 50.5744,
    y2: 82.5874,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7C104"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA505"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYellow);
export default __webpack_public_path__ + "static/media/yellow.2b15439e13b4632e4af80abf6f33c7d9.svg";
export { ForwardRef as ReactComponent };